(function () {
  angular.module("lif.controllers").controller("shoutoutBlockController", shoutoutBlockController);
  shoutoutBlockController.$inject = ['$rootScope', "$scope", '$document', "bootstrappedShoutoutBlockModel", "formService", "constants"];

  function shoutoutBlockController($rootScope, $scope, $document, bootstrappedShoutoutBlockModel, formService, constants) {
    var vm = this;
    vm.adding = false;
    vm.removing = false;
    vm.events = bootstrappedShoutoutBlockModel.events;
    vm.isEditable = bootstrappedShoutoutBlockModel.isEditable;
    vm.groupPageReference = bootstrappedShoutoutBlockModel.groupPageReference;
    vm.groupName = bootstrappedShoutoutBlockModel.groupName;
    vm.numberOfEventsToShow = bootstrappedShoutoutBlockModel.numberOfEventsToShow;
    vm.groupEventTypesToShow = bootstrappedShoutoutBlockModel.groupEventTypesToShow;
    vm.maximumNumberOfEventsToShow = 100;

    $scope.$onInit = function () {
      window.resizeLeftNavbar();
    };

    $rootScope.$on('groupEvent', function (event, groupEvent) {
      if (!((groupEvent.GroupEventType === constants.GroupEventType.File || groupEvent.GroupEventType === constants.GroupEventType.MeetingsFile) && groupEvent.Action === constants.Action.Delete)) {
        if (vm.groupEventTypesToShow.includes(groupEvent.GroupEventType.toString())) {
          //Unshift will temporarily add this event last because of a documented bug with AngularJs
          vm.events.unshift({
            Message: groupEvent.Message,
            User: groupEvent.User,
            Date: groupEvent.Date,
            Id: groupEvent.Id
          });
        }
      }
    });

    vm.showRemoveEventModal = function (event) {
      vm.eventToRemove = event;
      $("#removeEventItemModal").modal("show");
    };

    vm.addShoutout = function () {
      var newShoutout = vm.newShoutout;

      if (newShoutout.length > 0) {
        vm.adding = true;
        formService.addShoutout(vm.groupPageReference, vm.groupName, newShoutout).then(function (event) {
          vm.events.unshift({
            Message: event.Message,
            Date: event.Date,
            Id: event.Id,
            User: event.User
          });
          vm.newShoutout = "";
          vm.adding = false;
        }, function () {
          vm.adding = false;
        });
      }
    };

    vm.removeGroupEvent = function (event) {
      vm.removing = true;
      var index;
      vm.events.forEach(function (item, i) {
        if (item === event) {
          index = i;
        }
      });
      event.removing = true;
      formService.removeGroupEvent(vm.groupPageReference, event.Id).then(function () {
        vm.events.splice(index, 1);
        event.removing = false;
        $("#removeEventItemModal").modal("hide");
      }, function () {
        event.removing = false;
        $("#removeEventItemModal").modal("hide");
      });
    };

    vm.showMoreEvents = function () {
      if (vm.numberOfEventsToShow === bootstrappedShoutoutBlockModel.numberOfEventsToShow) {
        vm.numberOfEventsToShow = vm.maximumNumberOfEventsToShow;
      } else {
        vm.numberOfEventsToShow = bootstrappedShoutoutBlockModel.numberOfEventsToShow;
      }
    };
  }
})();